module.exports = __webpack_public_path__ + "static/media/bglogin.1ad23c02.svg";